module.exports = __webpack_public_path__ + "static/img/postgree.ea92d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/postgree.png
// module id = 523
// module chunks = 1